import { api } from "@/lib/api";
import { ApiResponse, ApiError, PaginationParams } from "@/interfaces/api.interface";
import { BaseService } from "./base.service";
import { store } from "@/store/store";
import { hideLoader, showLoader } from "@/store/slices/loaderSlice";

export interface IReport {
  id: string;
  companyName: string;
  companyId: string;
  levelName: string;
  levelId: string;
  subcontractorName: string;
  subcontractorId: string;
  activityName: string;
  aarNumber: string;
  wirNumber: string;
  areaStatus: string;
  aarStatus: string;
  assignmentDate: string | null;
  startDate: string | null;
  endDate: string | null;
  assignedBy: string;
  remarks: string;
  areaId: string;
  areaName: string;
}

export interface IReportParams extends PaginationParams {
  projectId: string;
}

class ReportService extends BaseService {
  constructor() {
    super("Report");
  }

  async getReports(params: IReportParams): Promise<ApiResponse<IReport[]>> {
    try {
      store.dispatch(showLoader());
      
      const queryParams = this.buildReportQueryParams(params);
      const res: any = await api.get(`${process.env.REACT_APP_BASE_URL}/api/Report?${queryParams}`);

      return {
        data: res.data.items,
        total: res.data.totalCount,
        error: null,
      };
    } catch (error) {
      return {
        data: null,
        error: this.handleError(error),
      };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  private buildReportQueryParams(params: IReportParams): URLSearchParams {
    const {
      pageNumber = 0,
      pageSize = 20,
      sort,
      filter,
      projectId,
    } = params;

    const paramsObj: Record<string, string> = {
      projectId: projectId,
      skip: pageNumber.toString(),
      take: pageSize.toString(),
    };

    // Add grid column filters (includes toolbar filters)
    if (filter) {
      paramsObj.filter = JSON.stringify(filter);
    }

    // Add sorting
    if (sort) {
      paramsObj.sort = JSON.stringify(sort);
    }

    return new URLSearchParams(paramsObj);
  }
}

export default new ReportService();
